<template>
  <div class="top-nav-backgroud">
    <div class="wrap-lg">
      <div style="display: flex;justify-content: space-between;height: 80px;">
        <my-link href="/" class="logo" @click="toHome">
          <img src="@/assets/img/logo.png"/>
        </my-link>
        <div class="topNav">
          <ul>
            <li>
              <my-link href="/">首页</my-link>
            </li>
            <li>
              <my-link href="/mall">日化商城</my-link>
            </li>
            <li>
              <my-link href="/solution">解决方案</my-link>
            </li>
            <li>
              <el-dropdown>
                  <span class="el-dropdown-link">
                    我们的服务<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                <el-dropdown-menu slot="dropdown" class="service-menu">
                  <service-menu></service-menu>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>
              <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    资源中心<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="/standard">
                    检验标准
                  </el-dropdown-item>
                  <el-dropdown-item command="/laws">
                    法律法规
                  </el-dropdown-item>
                  <el-dropdown-item command="/formula">
                    产品配方
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>
              <my-link href="/news">新闻资讯</my-link>
            </li>
            <li>
              <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    关于我们<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="/serviceProject">
                    服务项目
                  </el-dropdown-item>
                  <el-dropdown-item command="/consulting">
                    合作咨询
                  </el-dropdown-item>
                  <el-dropdown-item command="/contactUs">
                    联系我们
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>
              <my-link href="/vip">会员专区</my-link>
            </li>
          </ul>
        </div>
        <div class="search">
          <el-input
            class="inline-input"
            v-model="searchText"
            prefix-icon="el-icon-search"
            placeholder="请输入您要搜索的关键字"
          >
            <el-button style="color: #fff;background-color: #32A08C" slot="append" @click="handleSearch()">搜索</el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ServiceMenu from './serviceMenu'

export default {
  name: 'topNav',
  components: { ServiceMenu },
  data () {
    return {
      aboutShow: false,
      searchText: '',
      showMenuDiv: false
    }
  },
  methods: {
    showMenu () {
      if (this.showMenuDiv) {
        this.showMenuDiv = false
      } else {
        this.showMenuDiv = true
      }
    },
    toHome () {
      this.$route.push('/home')
    },
    handleSearch () {
      if (this.searchText) {
        window.open('/search?sq=' + this.searchText)
      }
    },
    handleCommand (command) {
      this.$router.push({
        path: command
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .search{
    margin-top: 20px;
  }
  .top-nav-backgroud{
    background: #FFFFFF;
    border-bottom: solid 1px #32A08C;
  }
  .logo {
    line-height: 80px;
    img {
      height: 74px;
      vertical-align: middle;
    }
  }
  .topNav {
    ul {
      margin: 0;
      padding: 0;
      margin-top: 24px;
    }
    ul li {
      display: block;
      float: left;
      line-height: 49px;
      padding: 0 10px;
      list-style: none;
      cursor: pointer;
      font-size: 16px;
      background: #ffffff;
      .el-dropdown-link,a {
        font-size: 16px;
        color: #303133;;
        text-decoration: none;
        &:hover {
          color: #32A08C;
        }
      }
    }
    .service-menu {
      position: absolute;
      z-index: 12;
      left: 250px;
      border-top: 4px solid #32A08C;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px
    }
  }
</style>
